var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrustpilot = function SvgTrustpilot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4706 9.1713H25.0351L17.2999 14.8287L17.3002 14.8299L12.5276 18.3254L17.9633 16.9023L17.5402 15.5772L20.2441 24L12.5089 18.325L4.77358 24L7.73528 14.8287L0 9.15373L9.56457 9.1713L12.5263 0L15.4706 9.1713Z",
    fill: "#99C12F"
  })));
};
export default SvgTrustpilot;